import { Model } from "@vuex-orm/core";
import config from "../configs/ResolutionVote";

import MeetingResolution from "./MeetingResolution";
import Mandate from "./Mandate";

export default class ResolutionVote extends Model {
  static get entity() {
    return "resolution_vote";
  }

  static fields() {
    return {
      id: this.attr(null),
      // ..
      mandate_id: this.attr(null),
      meeting_has_resolution_id: this.attr(null),
      // ..
      vote: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      presence_status: this.attr(null),

      meeting_resolution: this.belongsTo(MeetingResolution, "meeting_has_resolution_id"),
      mandate: this.belongsTo(Mandate, "mandate_id"),
      agency_id: this.attr(null),

      ignored_correspondence: this.attr(null),
      // Revote majority is only for local use
      revote_majority: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
